/**
 * Hex 与 Base64 互转工具
 */
export function hexToBase64(hex: string): string {
  return btoa(hex.match(/.{2}/g)!.map((byte) => String.fromCharCode(parseInt(byte, 16))).join(""))
}

export function base64ToHex(base64: string): string {
  return atob(base64).split("").map((c) => c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
}
